import { portalApi } from '@/axios'

export default class ImageService {
  /**
   * Store an image.
   *
   * @param {Context} context
   * @param {object} image
   *
   * @return {Promise}
   */
  static save (context, image) {
    return portalApi.post(this.endpoint(context), image).then(response => {
      return response.data
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Delete image.
   *
   * @param {Context} context
   * @param {string} reference
   *
   * @return {Promise}
   */
  static delete (context, reference) {
    return portalApi.delete(`${this.endpoint(context)}/${reference}`)
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context) {
    return `${context.endpoint(['business', 'merchant', 'configuration'])}/images`
  }
}
